import {
	ADD_MESSAGES,
	CREATE_MESSAGE,
	DELETE_MESSAGE,
	SET_CONVERSATION_ID,
	SET_CURRENT_CONVERSATION,
	SET_CURRENT_TOKEN_AMOUNT,
	SET_ERROR,
	SET_IS_EMPTY_CHAT,
	SET_IS_MENU_VISIBLE,
	SET_TITLE,
	SET_TOKENS_SPENT,
	SET_CURRENT_CHAT_CONTEXT,
	ADD_CONVERSATION_LIST,
	RESET_CURRENT_CHAT_STATE,
	SET_STREAMING_MESSAGE,
	SET_IS_CURRENTLY_STREAMING,
	CREATE_CONVERSATION,
	SET_IS_CURRENTLY_FETCHING,
	SET_TYPE_OF_VIEW,
} from '#app/constants/chat.ts'
import { type State, type Action } from '#types/chat/index.ts'
import { addConversationList } from './reducerFunctions/addConversationList.ts'
import { addMessages } from './reducerFunctions/addMessages.ts'
import { createConversation } from './reducerFunctions/createConversation.ts'
import { createMessage } from './reducerFunctions/createMessage.ts'
import { deleteMessage } from './reducerFunctions/deleteMessage.ts'
import { resetCurrentChatState } from './reducerFunctions/resetCurrentChatState.ts'
import { setConversationId } from './reducerFunctions/setConversationId.ts'
import { setCurrentChatContext } from './reducerFunctions/setCurrentChatContext.ts'
import { setCurrentConversation } from './reducerFunctions/setCurrentConversation.ts'
import { setCurrentTokenAmount } from './reducerFunctions/setCurrentTokenCount.ts'
import { setError } from './reducerFunctions/setError.ts'
import { setIsCurrentlyFetching } from './reducerFunctions/setIsCurrentlyFetching.ts'
import { setIsCurrentlyStreaming } from './reducerFunctions/setIsCurrentlyStreaming.ts'
import { setIsEmptyChat } from './reducerFunctions/setIsEmptyChat.ts'
import { setIsMenuVisible } from './reducerFunctions/setIsMenuVisible.ts'
import { setStreamingMessage } from './reducerFunctions/setStreamingMessage.ts'
import { setTitle } from './reducerFunctions/setTitle.ts'
import { setTokenSpent } from './reducerFunctions/setTokenSpent.ts'
import { setTypeOfView } from './reducerFunctions/setTypeOfView.ts'

export function globalChatReducer({
	state,
	action,
}: {
	state: State
	action: Action
}): State {
	switch (action.type) {
		case ADD_MESSAGES:
			return addMessages(state, action)
		case CREATE_MESSAGE:
			return createMessage(state, action)
		case DELETE_MESSAGE:
			return deleteMessage(state, action)
		case SET_CONVERSATION_ID:
			return setConversationId(state, action)
		case SET_CURRENT_CONVERSATION:
			return setCurrentConversation(state, action)
		case SET_CURRENT_TOKEN_AMOUNT:
			return setCurrentTokenAmount(state, action)
		case SET_ERROR:
			return setError(state, action)
		case SET_IS_MENU_VISIBLE:
			return setIsMenuVisible(state, action)
		case SET_IS_EMPTY_CHAT:
			return setIsEmptyChat(state, action)
		case SET_TITLE:
			return setTitle(state, action)
		case SET_TOKENS_SPENT:
			return setTokenSpent(state, action)
		case SET_CURRENT_CHAT_CONTEXT:
			return setCurrentChatContext(state, action)
		case ADD_CONVERSATION_LIST:
			return addConversationList(state, action)
		case RESET_CURRENT_CHAT_STATE:
			return resetCurrentChatState(state, action)
		case SET_STREAMING_MESSAGE:
			return setStreamingMessage(state, action)
		case SET_IS_CURRENTLY_STREAMING:
			return setIsCurrentlyStreaming(state, action)
		case CREATE_CONVERSATION:
			return createConversation(state, action)
		case SET_IS_CURRENTLY_FETCHING:
			return setIsCurrentlyFetching(state, action)
		case SET_TYPE_OF_VIEW:
			return setTypeOfView(state, action)
		default:
			return state
	}
}
